import React from 'react'
import { css } from '@linaria/core'
import EventText from './EventText'
import EventIcon from './EventIcon'
import EventConnector from './EventConnector'

const imageConnectorCss = css`
  position: relative;
  overflow: hidden;
`

/**
 * Event component for WorldEvents info card.
 * @param {object} props - Props
 * @returns {JSX} Component
 */
export default function Event({ gender, event, disableConnector, birthYear }) {
  const { year, title, description } = event
  return (
    <>
      <div className={imageConnectorCss}>
        <EventIcon gender={gender} />
        {!disableConnector && <EventConnector />}
      </div>
      <EventText year={year} birthYear={birthYear} title={title} text={description} />
    </>
  )
}
